// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class QuoteStatus extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Statuses = {
    New: 1,
    Pending: 2,
    Awarded: 3,
    Declined: 4
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  name?: string;
}

